<template>
  <div id="shop-page">
    <h1 class="shop-head-title">店舗をお選びください</h1>
    <div id="shop-list" v-if="prepared" class="shoplist">
      <div class="shop" v-for="(shop) in shops" :key="`shop-${shop.id}`"
      :class="{selected: selectedShopId == shop.id, zoomIn: selectedShopId == shop.id}"
      @click="onClickShop(shop)"
      >
        <div class="-pict">
          <img :src="require(`@/assets/img/shop-${shop.id}.jpg`)"/>
        </div>

        <div class="-detail">
          <div class="shopname">
            <img src="../assets/img/amaze_logo_grey.png"/>
            <b v-text="shop.name"></b>
          </div>
          <!-- 住所、案内文はDBにないのでここで生成 -->
          <div class="addr" v-if="shop.id == 1">
            中和泉3-28-2<br/>田中橋交差点にある本店です
          </div>
          <div class="addr" v-if="shop.id == 2">
            東和泉1-15-6 狛江駅南口<br/>ファミマ横のお店です
          </div>
          <div class="button">
            <b>こちらのお店を選ぶ</b>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'

export default {
  mounted() {
    this.loadShops();
  },
  created() {

  },
  computed: {
    ...mapState("shop", ["shops"]),
    ...mapGetters("shop", ["selectedShopId"]),
    prepared() {
      return this.shops.length > 0
    }
  },
  methods: {
    ...mapActions("shop", ["loadShops"]),
    ...mapMutations("shop", ["selectShop"]),
    
    onClickShop(shop) {
      this.selectShop(shop.id);
      setTimeout(()=>this.$router.push('/stat'), 500);
    }
  },
}
</script>

<style lang="scss" scoped>
.shop-head-title {
  text-align: center;
}

.shoplist {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 1em;
  gap: 1em;
  .shop {
    width: 45%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    border: solid 1px silver;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;

    .-pict {
      width: 100%;
      height: 25vh;
      overflow: hidden;

      > img {//店舗画像
        width: auto;
        max-height: 100%;
        object-fit: cover;
      }
    }

    .-detail {
      display: flex;
      flex-direction: column;

      .shopname {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: start;

        img {//ロゴ画像
          // object-fit: cover;//トリミング
          width: auto;
          height: 1.8em;
        }
        b {
          font-size: 1.6em;
          padding: 0;
        }
      }

      .addr {
        flex: 1;
        padding-left: 1em;
      }

      .button {
        flex: 2;
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
        > b {
          padding: .1em .5em;
        }
      }
    }
    
    &.selected {
      border-color: #fe4902;
      .shopname {
        color: #fe4902;
      }
      .-detail .button b {
        background-color: #fe4902;
        color: white;
      }
    }
    /*
    .zoom-in {//選ばれたら拡大とか
      margin: 40px;
      width: 70px;
      height: 70px;
      background: #0091EA;
      transition: 1s;
    }
    */
  }
}
@media screen and (max-width: 1200px) {
  .shoplist {
    .shop {
      width: 100%;

      .-detail {
        .button {
          justify-content: start;
        }
      }
    }
  }
}
@media screen and (max-width: 620px) {
  .shoplist {
    .shop {
      .-detail {
        .shopname {
          flex-direction: column;
          align-items: flex-start;
          padding-left: 1em;
        }
        .button {
          > b {
            margin-left: 1em;
            .hidden-sm {
              display: none;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 420px) {
  .shoplist {
    .shop {
      .-detail {
        .shopname {
          img {//ロゴ画像
            height: 1.6em;
          }
          b {
            font-size: 1.4em;
          }
        }

      }
    }
  }
}
</style>